import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 400 },
    listenFormdata: { type: Boolean, default: false },
    autoSubmit: { type: Boolean, default: false },
  }

  connect() {
    this.submitBound = debounce(this.submit.bind(this), this.delayValue)
    this.element.addEventListener("change", this.submitBound)
    this.lastParamsStr = null
    if (this.listenFormdataValue)
      this.element.addEventListener(
        "formdata",
        (this._cleanFormBound = this.#cleanForm.bind(this)),
      )
  }

  disconnect() {
    this.element.removeEventListener("change", this.submitBound)
    if (this.listenFormdataValue)
      this.element.removeEventListener("formdata", this._cleanFormBound)
  }

  async submit() {
    const params = this.#buildParams(new FormData(this.element))
    if (!params) return

    if (this.autoSubmitValue) {
      this._pendingParams = params
      return this.element.requestSubmit()
    }

    this.dispatch("changed", { detail: { params }, bubbles: true })
  }

  #cleanForm(e) {
    if (!this._pendingParams) return e.preventDefault()

    for (const [k, v] of Object.entries(this._pendingParams)) {
      Array.isArray(v)
        ? v.forEach((val) => e.formData.append(k, val))
        : e.formData.set(k, v)
    }
    e.formData.delete("date_range")

    this._pendingParams = null
  }

  #buildParams(fd) {
    const params = {}

    // 特殊处理：date_range 需要拆分为 start_date 和 end_date
    if (fd.has("date_range")) {
      const [start_date, end_date] = fd
        .get("date_range")
        .split(" ~ ")
        .map((s) => s.trim())
      if (!start_date || !end_date) return null
      params.start_date = start_date
      params.end_date = end_date
    } else if (
      !fd.has("target_date") &&
      !fd.has("start_date") &&
      !fd.has("bid_date")
    )
      return null

    for (const [key, value] of fd.entries()) {
      if (key === "date_range") continue
      if (!params[key]) params[key] = value
    }

    // 特殊处理：checkboxes 需要合并成数组
    document.querySelectorAll('input[type="checkbox"][name]').forEach((el) => {
      if (el.checked) {
        if (!Array.isArray(params[el.name])) params[el.name] = []
        params[el.name].push(el.value)
      }
    })

    // 防止重复请求
    const paramsStr = new URLSearchParams(params).toString()
    if (this.lastParamsStr === paramsStr) return null
    this.lastParamsStr = paramsStr
    return params
  }
}
